import IncExc from './IncExc';
import { FilterOptionsGridProps } from './FilterOptionsGrid';
import { P2GDropdown } from '@parcel2go/core-ui';

const FilterOptionsGridDrop = (props: FilterOptionsGridProps) => (
  <IncExc mode={props.mode} setMode={props.setMode}>
    <P2GDropdown
      value={props.selected[0]}
      options={[{ value: '', text: props.filterItem.name }, ...props.filterItem.options]}
      id={props.filterItem.name}
      label={props.filterItem.label ?? props.filterItem.name}
      onChange={(v: string) => props.toggleSelected(v)}
    />
  </IncExc>
);

export default FilterOptionsGridDrop;
